import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  readonly heroSrc = 'assets/images/products-factory.png';
  readonly biopolymerSrc = 'assets/images/products-biopolymer.png';
  readonly packagingSrc = 'assets/images/products-packaging.png';
}

